export const renderImgSrc = (imgSrc, name) => {
    let format = "png"

    if(imgSrc){

        if (imgSrc.startsWith("/9j/")) format = "jpeg";       // JPEG/JPG
        else if (imgSrc.startsWith("iVBORw0KGgo")) format = "png"; // PNG
        else if (imgSrc.startsWith("R0lGODdh") || imgSrc.startsWith("R0lGODlh")) format = "gif"; // GIF
        else if (imgSrc.startsWith("UklGR")) format = "webp"; // WebP

        return `data:image/${format};base64,${imgSrc}`
    }
    return `https://ui-avatars.com/api/?name=${name}&background=e8eaff&color=2c25c4`
}